// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__3zjRB","hiddenLink":"styles_hiddenLink__3Ok3o"};